import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiFetch } from "./api";
import { tipuriTichete } from "../portalData";
import { formatData } from "../utils/expirare";

const STATUS_TEXT = { nou: "Nou", in_lucru: "În lucru", rezolvat: "Rezolvat" };

export default function Solicitari() {
  const location = useLocation();
  const masinaPreselectata = location.state?.masina || "";

  const [masini, setMasini] = useState([]);
  const [tichete, setTichete] = useState([]);
  const [tip, setTip] = useState(tipuriTichete[0]);
  const [masina, setMasina] = useState(masinaPreselectata);
  const [mesaj, setMesaj] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  // Încarcă mașinile (pentru dropdown) și istoricul tichetelor.
  const incarcaTichete = () => {
    apiFetch("/tichete").then((d) => setTichete(d.tichete || [])).catch(() => {});
  };
  useEffect(() => {
    apiFetch("/masini").then((d) => setMasini(d.masini || [])).catch(() => {});
    incarcaTichete();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const data = await apiFetch("/tichete", {
        method: "POST",
        body: JSON.stringify({ tip, masina, mesaj }),
      });
      if (data && data.ok) {
        setStatus("success");
        setMesaj("");
        incarcaTichete();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="solicitari">
      <div className="dash__head">
        <h1>Solicitări</h1>
        <p>Trimite o cerere către echipa LEASEIN. Revenim cât mai repede.</p>
      </div>

      <div className="solicitari__grid">
        <div className="solicitari__form-wrap">
          <h2>Solicitare nouă</h2>
          {status === "success" ? (
            <div className="solicitari__success">
              <div className="solicitari__success-icon">
                <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <h3>Solicitare trimisă!</h3>
              <p>Am primit cererea ta. Te contactăm în cel mai scurt timp.</p>
              <button className="btn btn--ghost" onClick={() => setStatus("idle")}>
                Trimite altă solicitare
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="solicitari__form">
              <label>
                Tip solicitare
                <select value={tip} onChange={(e) => setTip(e.target.value)}>
                  {tipuriTichete.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </label>
              <label>
                Mașina (opțional)
                <select value={masina} onChange={(e) => setMasina(e.target.value)}>
                  <option value="">— alege mașina —</option>
                  {masini.map((m) => (
                    <option key={m.id} value={m.nrInmatriculare}>
                      {m.nrInmatriculare} — {m.model}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Mesaj
                <textarea
                  rows="5"
                  value={mesaj}
                  onChange={(e) => setMesaj(e.target.value)}
                  placeholder="Descrie pe scurt ce ai nevoie..."
                  required
                />
              </label>
              {status === "error" && (
                <small className="solicitari__error">
                  Ceva nu a mers. Încearcă din nou.
                </small>
              )}
              <button type="submit" className="btn btn--primary" disabled={status === "sending"}>
                {status === "sending" ? "Se trimite..." : "Trimite solicitarea"}
              </button>
            </form>
          )}
        </div>

        <div className="solicitari__istoric">
          <h2>Istoric solicitări</h2>
          {tichete.length === 0 ? (
            <div className="dash__empty">Nu ai trimis nicio solicitare încă.</div>
          ) : (
            <ul className="tichete">
              {tichete.map((t) => (
                <li className="tichet" key={t.id}>
                  <div className="tichet__top">
                    <span className="tichet__tip">{t.tip}</span>
                    <span className={`tichet__status tichet__status--${t.status}`}>
                      {STATUS_TEXT[t.status] || t.status}
                    </span>
                  </div>
                  <p className="tichet__mesaj">{t.mesaj}</p>
                  <div className="tichet__meta">
                    {t.vehicul_id && <span>{t.vehicul_id}</span>}
                    <span>{formatData(t.creat_la)}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
